export default {
  permissions: [],
  permissionsSignature: [],
  inviteCode: '',
  applicationId: 0,
  isDraft: false
}
